export function getIconPath(icon: string): string {
    if (!icon) return ""
    return `/assets/imgs/icons/${icon}.svg`
}
